import React from 'react'
import PropTypes from 'prop-types'
import { CheckboxField } from '@entrata/portals-common/lib/boxed-fields'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
/** A styled checkbox input with a label */
import styled from '@emotion/styled'

const StyledCheckbox = styled(CheckboxField)`
  div:first-child {
    background: ${({ theme, value, isIndeterminate }) =>
      value || isIndeterminate
        ? theme.button_secondary?.background
        : theme.rounded_checkbox.background_default};
    border: ${({ theme }) =>
      `1px solid ${theme.rounded_checkbox.border_color}`};
    box-sizing: border-box;
    border-radius: 6px;
    outline: none;
    svg {
      height: 12px;
      width: 14px;
    }
  }

  label {
    color: ${({ theme }) => getEmbeddedViewFlag() && theme.primary.base};
  }

  [hidden] {
    display: initial !important;
  }
`

const RoundedCheckBox = React.forwardRef((props, ref) => {
  return <StyledCheckbox {...props} ref={ref} />
})

RoundedCheckBox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),

  value: PropTypes.bool,
}

export default RoundedCheckBox
